import { InjectionToken } from '@angular/core';
import { FeatureConfig } from './toggle-router.service';
import { Observable } from 'rxjs';

/**
 * @ignore
 * Injection token required to add experimental configuration to the toggle
 * router service.
 */
export const FEATURE_CONFIG = new InjectionToken<FeatureConfig>('feature router configuration');

export type FeatureConfigInitializer = () => Observable<FeatureConfig>;

export async function featureConfigFactory(featureConfigInitializer: FeatureConfigInitializer) {
  const result =
    (await featureConfigInitializer()
      .toPromise()
      .catch(() => console.error('Could not get feature configs'))) || {};
  return result;
}
